<template>
  <div class="main-menu primary">
    <v-tabs background-color="primary" dark optional grow>
      <v-tab @click="$navigateTo('Nearby')">Umgebung</v-tab>
      <v-tab @click="$navigateTo('Events')">Veranstaltungen</v-tab>
      <v-tab @click="$navigateTo('Discounts')">Angebote</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "MainMenu"
};
</script>
